import { createApi,fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const UsersApi = createApi({
    reducerPath: 'UsersApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'http://localhost:5000/user/' }),
    tagTypes:['user'],
    endpoints: (builder) => ({
      getAllUsers:  builder.query({
        query: () => {
         return {
          url: `getAll/`,
          method: "GET",
          headers: {
           "content-type": "application/json",
          },
         };
        },
       }),
       getUserById:  builder.query({
        query: (id) => {
         return {
          url: `getOne/`+id,
          method: "GET",
          headers: {
           "content-type": "application/json",
          },
         };
        },
       }),
       getUserByEmail:  builder.query({
        query: (email) => {
         return {
          url: `getbyemail/`+email,
          method: "GET",
          headers: {
           "content-type": "application/json",
          },
         };
        },
       }),
      }),
      
    });

  // Export hooks for usage in functional components, which are
  // auto-generated based on the defined endpoints
  export const { useGetAllUsersQuery,useGetUserByIdQuery,useGetUserByEmailQuery } = UsersApi;